<template>
  <div class="home-warp ">
    <Alert
      :show.sync="alertShow"
      :title="alertTitle"
      :content="alertContent"
      :transify="transify"
      :add-ga="addGA"
    />
    <ws-header
      :title="transify['WISHING_TITLE']"
      :userInfo="userInfo"
      :rightShow="'id'"
      :EvtQuestion="EvtQuestion"
    ></ws-header>
    <div class="home">
      <div class="left">
        <div class="box background-set-full">
          <!-- 标题 -->
          <div class="title skew-15">
            <div class="title-txt">{{transify['WISHING_POOL_TITLE']}}</div>
          </div>
          <!-- 转盘 -->
          <div class="item-warp">
            <div class="item-bg background-set-full" v-for="item in checkedItems" :class="[{'item-gray':redeemed.includes(item)}]">
                <img class="item " :src="pkToItem(item)['img']"/>
                <span class="item_num" v-show="pkToItem(item)['num']>1">x{{pkToItem(item)['num']}}</span>
                <i class=" background-set-full" :class="{'current-show':currentPk ===item}"></i>
            </div>
          </div>
          <!-- 分割线 -->
          <i class="box-line"></i>
          <div class="box-label">{{transify['WISHING_POOL_TIPS']}}</div>
        </div>
      </div>
      <div class="right">
        <!-- 获得星 -->
        <div class="star-energy">
          <i class="star background-set-full"></i>
          <span class="energy-txt">{{transify['WISHING_ENERGY_NAME']}}</span>
          <span class="energy-now">{{energy}}</span>
        </div>
        <!-- 进度条 -->
        <div class="process-warp">
          <div class="process background-set-full">
          </div>
            <!--  达标值 -->
            <div class="target-label">
              {{energy_stage_1}}
            </div>
            <div class="target-label split-line2">
              {{energy_stage_2}}
            </div>
            <div class="target-label split-line3">
              {{energy_stage_3}}
            </div>
            <div class="target-label split-line4">
              {{energy_stage_4}}
            </div>
            <!-- 分割线 -->
            <div class="split-line background-set-full ">  
            </div>
            <div class="split-line background-set-full split-line2">  
            </div>
            <div class="split-line background-set-full split-line3">  
            </div>
            <div class="split-line background-set-full split-line4">  
            </div>

            <!-- 礼物图标 -->
            <div @click="evtRedeem(0)" class="background-set-full gifts" :class="{'gifts-activate':energy>energy_stage_1 || energy===energy_stage_1}">
               <i
              class="red-icon"
              v-show="redeem['0']<0&&(energy>energy_stage_1 || energy===energy_stage_1)"
            ></i>
            </div>
            <div @click="evtRedeem(1)" class="background-set-full gifts split-line2" :class="{'gifts-activate':energy>energy_stage_2 || energy===energy_stage_2}">
               <i
              class="red-icon"
             v-show="redeem['1']<0&&(energy>energy_stage_2 || energy===energy_stage_2)"
            ></i>
            </div>
            <div @click="evtRedeem(2)" class="background-set-full gifts split-line3" :class="{'gifts-activate':energy>energy_stage_3 || energy===energy_stage_3}">
               <i
              class="red-icon"
              v-show="redeem['2']<0&&(energy>energy_stage_3 || energy===energy_stage_3)"
            ></i>
            </div>
            <div @click="evtRedeem(3)" class="background-set-full gifts split-line4" :class="{'gifts-activate':energy>energy_stage_4 || energy===energy_stage_4}">
               <i
              class="red-icon"
              v-show="redeem['3']<0&&(energy>energy_stage_4 || energy===energy_stage_4)"
            ></i>
            </div>
        </div>
        <!-- 任务栏目 -->
        <div class="task-warp">
            <div class="task-item" v-for="(item,index) in task" :key="'task'+index">
               <div class="score-star">
                 <i class="star background-set-full star-task"></i>
                  <span class="score background-set-full">
                    <div class="score-txt">{{item.energy}}</div>
                  </span>
               </div>
               <div class="task-txt">{{item.desc}}</div>
               <!-- 可领取 -->
              <div class="fire-up background-set-full fire-up-activate" v-if="item.status===1" @click="fireUp(item)">
                <div class="fire-up-txt-activate">
                  {{transify['WISHING_ENERGY_REDEEM'] || 'WISHING_ENERGY_REDEEM'}}
                </div>
              </div>
              <!-- 未达成 -->
               <div class="fire-up background-set-full " v-if="item.status===0" >
                 <div class="fire-up-txt">
                  {{transify['WISHING_ENERGY_REDEEM'] || 'WISHING_ENERGY_REDEEM'}}
                </div>
               </div>
               <!-- 已领取 -->
               <div class="fire-up background-set-full " v-if="item.status===2" >
                 <div class="fire-up-txt">
                  {{transify['WISHING_REDEEMED'] || 'WISHING_REDEEMED'}}
                </div>
               </div>
            </div>
        </div>
      </div>
    </div>
    <!-- 领取成功-->
    <ws-dialog :show.sync="congratulationShow" :closeAble="true">
      <!-- 选中物品 -->
      <template slot="content">
        <div class="chosen-title">
            {{transify['WISHING_CONGRATULATIONS']}}
        </div>
        <div class="chosen-confirm">
          <div
            class="item-bg background-set-full"
          >
            <img class="item" :src="pkToItem(redeemItem)['img']" />
            <div class="item-name">
              <p v-marquee v-if="congratulationShow">
                <span>{{ pkToItem(redeemItem)["name"] }}</span>
              </p>
            </div>
            <span class="item_num item_num2" v-show="pkToItem(redeemItem)['num']>1">x{{pkToItem(redeemItem)['num']}}</span>
          </div>
          <div class="chosen-confirm-btn">
            <div class="confirm-btn background-set-full confirm-btn-ok" @click="congratulationShow=false">
              <div class="confirm-btn-ok-txt skew-15">{{transify['WISHING_CONFIRM_OK']}}</div>
            </div>
          </div>
          <div class="change-token" v-if="give_token===1">
            {{transify['UNIQUE_BUY_ALREADY_HAVE'] || 'You already own this item, if you purchase it again, it will be converted to FF tokens.'}}
          </div>
          <div class="change-token" v-else>
            {{transify['COMMON_TIPS_ITEM'] || 'the rewards will be sent directly to your vault'}}
          </div>
        </div>
      </template>
    </ws-dialog>
    <!-- 规则弹窗 -->
    <ws-dialog :show.sync="ruleShow" :closeAble="true">
      <div
        slot="content"
        class="can-scoll-y"
        v-html="rule"
        style="color:#ffdd86;"
      ></div>
    </ws-dialog>
  </div>
</template>

<script>
import wsHeader from "../../components/productComponents/wsHeader";
import utils from '../../utils/common'
import anime from 'animejs'
// import { addGA } from '../../utils/ga'
import gaTool from '../../utils/ga'
import Alert from '../../components/alert/Alert.vue'

export default {
  name: "task",
  components: {
    wsHeader,
    Alert
  },
  data() {
    return {
                        alertShow:false,
            alertTitle:'',
            alertContent:'',
      pkMap: {},
      userInfo: null,
      guide: "",
      rule: "",
      checkedItems: [], //选中物品
      allItemCollections: [],
      ruleShow: false, //规则显示
      congratulationShow: false, //二次确认选中物品展示
      event_config:null,
      task:[],//任务合集
      redeemed:[],//已领取的
      redeem:{//阶段领取过
        "0":-1,
        "1":-1,
        "2":-1,
        "3":-1,
      },
      fired:[],//已点亮的
      energy:0,//能量
      energy_stage_1:0,
      energy_stage_2:0,
      energy_stage_3:0,
      energy_stage_4:0,
      timer:null,
      currentPk:-1, //当前转盘指向pk
      canClick:true,
      redeemItem:null,
      give_token:0,
      transify:null,
    };
  },
  watch:{
    energy(){
      this.ProcessControl()
    }
  },
  computed: {
    // pk转为item内容
    pkToItem() {
      return pk => {
        let result = {};
        this.allItemCollections.forEach(e => {
          if (e.pk == pk) {
            result = e;
          }
        });
        return result;
      };
    }
  },
  methods: {
    addGA:gaTool.addGA,
    // 进度计算
    calcPercent(energy){
      let energy_stage_1 = this.energy_stage_1
      let energy_stage_2 = this.energy_stage_2
      let energy_stage_3 = this.energy_stage_3
      let energy_stage_4 = this.energy_stage_4
      
      if(energy<0){
        return 0
      }
      if((energy>0 || energy===0)&&(energy<energy_stage_1 || energy===energy_stage_1)){
        return (energy/energy_stage_1)*25
      }
      if((energy>energy_stage_1)&&(energy<energy_stage_2 || energy===energy_stage_2)){
        return (25*energy+25*energy_stage_2-50*energy_stage_1)/(energy_stage_2-energy_stage_1)
      }
      if((energy>energy_stage_2)&&(energy<energy_stage_3 || energy===energy_stage_3)){
        return (25*energy+50*energy_stage_3-75*energy_stage_2)/(energy_stage_3-energy_stage_2)
      }
      if((energy>energy_stage_3)&&(energy<energy_stage_4 || energy===energy_stage_4)){
        return  (25*energy+75*energy_stage_4-100*energy_stage_3)/(energy_stage_4-energy_stage_3)
      }
      if(energy>energy_stage_4){
        return 100
      }
    },
    // 规则按钮
    EvtQuestion() {
      if(!this.canClick)return;
      this.ruleShow = true;
    },
    // 进度控制
    ProcessControl(){
      let width = this.calcPercent(this.energy)
      anime({
        targets: '.process',
        width: `${width.toString()}%`,
        easing: 'easeInOutQuad',
        duration: 500
      });
    },
    // 点亮
    fireUp(item){
      if(!this.canClick)return;
      this.canClick =false
      this.$request.post(this.$api.fireup, {pk:item.pk}).then(response => {
          if(response.status !== 'success'){
            this.ga.errorGA(response.msg);
            this.$wsMessage("network", false, true);
            return
          }
          this.canClick = true
          this.energy+=item.energy
          item.status = 2
        }).catch(err => {
          if (err === "repeat") {
            return;
          }
          this.ga.errorGA(err);
          utils.catchTransify(err,this.transify,this)
          // this.$wsMessage("network", false, true);
        });
    },
    // 领取
    evtRedeem(stage){
      if(!this.canClick)return;
      if(stage===0&&this.energy<this.energy_stage_1) return;
      if(stage===1&&this.energy<this.energy_stage_2) return;
      if(stage===2&&this.energy<this.energy_stage_3) return;
      if(stage===3&&this.energy<this.energy_stage_4) return;
      // 已领取过
      if(this.redeem[stage.toString()]>-1) return;
      this.canClick = false
      this.startRolling(100)
      this.redeemItem =null
      this.give_token=0
      this.$request.post(this.$api.redeem, {stage:stage}).then(response => {
          if(response.status !== 'success'){
            this.ga.errorGA(response.msg);
            this.$wsMessage("network", false, true);
            return
          }
          this.stopRolling(()=>{
            this.redeemItem = response.data['pk']
            this.give_token = response.data['give_token']
            this.currentPk = this.redeemItem
           
          },()=>{
             this.redeemed.push(this.redeemItem)
             this.redeem[stage.toString()] = this.redeemItem
              this.congratulationShow = true
              this.canClick = true
          })

        }).catch(err => {
          if (err === "repeat") {
            return;
          }
          this.stopRolling()
          this.ga.errorGA(err);
          this.ga.errorGA(err);
          utils.catchTransify(err,this.transify,this)
          // this.$wsMessage("network", false, true);
        });
      
    },
    // 开始转
    startRolling(speed){
      // 重排序
      let rewardSort = [this.checkedItems[0],this.checkedItems[1],this.checkedItems[3],this.checkedItems[2]]
        let index = -1
        if(this.redeemed.length<3){
          this.timer = setInterval(() => {
            // 查找两个数组重复部分并去除得到新数组
            let rewardSort2 = JSON.parse(JSON.stringify(rewardSort))
            rewardSort2.forEach((el,index)=>{
              if(this.redeemed.includes(el)){
                rewardSort[index] = false
              }
            })
            let tmp =[]
            rewardSort.forEach(ele=>{
              if(ele){
                tmp.push(ele)
              }
            })
            rewardSort = tmp
            index++
            // 如果已领取，则跳过
          this.currentPk = rewardSort[index.toString()]
          if(index>rewardSort.length-2){
            index = -1
          }
         
        }, speed);
        }else{
          Object.keys(rewardSort).forEach(ele=>{
            if(!this.redeemed.includes(rewardSort[ele.toString()])){
              this.currentPk = rewardSort[ele.toString()]
            }
          })
        }
      },
      // 结束转动
    stopRolling(cb1,cb2){
        let timer = setTimeout(() => {
          clearTimeout(this.timer)
          clearTimeout(timer)
          this.timer = null
          timer = null
          if(cb1){
            cb1()
          }
          let timer2 = setTimeout(() => {
            if(cb2){
              cb2()
            }
            clearTimeout(timer2)
          }, 1000);
        }, 3000);
      },
  },
  created() {
    if(this.$route.query.choices&&this.$route.query.choices.length>0){
      this.checkedItems = this.$route.query.choices
      this.checkedItems.forEach((ele,index)=>{
        this.checkedItems[index] = Number(ele)
      })
    }
    if (this.globalConfig) {
            // th 弹窗部分
          if (this.globalConfig.policy_popup) {
            const {
              popup_title: policyTitle,
              popup_content: policyCtx,
              checked: policyHide
            } = this.globalConfig.policy_popup
            this.alertShow = !policyHide
            this.alertTitle = policyTitle
            this.alertContent = policyCtx
          }
      this.userInfo = this.globalConfig.player;
      this.allItemCollections = this.globalConfig.event_config.pool;
      this.rule = this.globalConfig.event_config.rule;
      this.guide = this.globalConfig.event_config.guide;
      this.event_config = this.globalConfig.event_config
      this.energy_stage_1 = this.globalConfig.event_config.energy_stage_1
      this.energy_stage_2 = this.globalConfig.event_config.energy_stage_2
      this.energy_stage_3 = this.globalConfig.event_config.energy_stage_3
       this.energy_stage_4 = this.globalConfig.event_config.energy_stage_4
      this.task = this.globalConfig.event_config.task
      this.fired = this.globalConfig.player_event.fired
      this.transify = this.globalConfig.transify
      this.energy = this.globalConfig.player_event.energy
      this.redeem = this.globalConfig.player_event.redeemed
      if(this.checkedItems.length<1){
        this.checkedItems = this.globalConfig.player_event.choices
        if(this.checkedItems.length<1){
          this.$router.push('/')
        }
      }
      const tmpRedeem = Object.keys(this.redeem)
      tmpRedeem.forEach(ele=>{
        if(this.redeem[ele]>0){
          this.redeemed.push(this.redeem[ele])
        }
      })
    }
  },
};
</script>
<style lang="scss" scoped>
.home-warp {
  width: 100vw;
  height: 100vh;
  background-repeat: no-repeat;
  background-size: 100% 100%;
   .item_num{
      position: absolute;
      @include res-size(
        $bottom:4px,
        $right:12px
      )
    }
    .item_num{
      @include res-size(
        $bottom:12px,
      )
    }
  .skew-15{
    transform: skew(-10deg)
  }
  .selected{
    position: absolute;
    left: 0;
    top: 0;
    @include res-size($width: 122px, $height: 122px);
  }
  .chosen-title {
    text-align: center;
    background: linear-gradient(top, #fbdca1, #ffd74a);
    background: -webkit-linear-gradient(top, #fbdca1, #ffd74a);
    -webkit-background-clip: text;
    color: transparent;
    @include res-size($font-size: 60px);
  }
  .chosen-confirm {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    // @include res-size($margin-top: 10px);
    .item-gray {
      filter: brightness(0.3) contrast(91%) grayscale(100%);
    }
    .item-bg {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      @include res-size($width: 122px, $height: 122px, $margin: 25px);
      // overflow-x: hidden;
    
    }
    .item-name {
      @include res-size(
        $height: 30px,
        $line-height: 30px,
        $width: 122px,
        $font-size: 24px,
        $margin-left: -61px,
        $bottom: -40px
      );
      position: absolute;
      left: 50%;
      text-align: center;
      overflow: hidden;
      p {
        text-align: center;
        white-space: nowrap;
        color: #ffdd86;
      }
    }
    .item {
      @include res-size($width: 90px);
    }
    .chosen-confirm-btn{
      display: flex;
      margin-left: auto;
      margin-right: auto;
      text-align: center;
      @include res-size(
          $width:690px,
          $height:90px,
          $margin-top:45px,
          $font-size:50px,
          $line-height:90px,
        );
      justify-content: center;
      .confirm-btn{
        @include res-size(
          $width:330px,
          $height:90px,
          // $line-height:90px,
        )
      }
    }
    .confirm-btn-ok-txt{
          color: #fff1da;
        //  background: linear-gradient(top,#742121,#110505); 
          // background: -webkit-linear-gradient(top,#742121,#110505); 
          // -webkit-background-clip: text;
          // color: transparent;
      }
      .change-token{
        position: absolute;
        text-align:center;
        color: #fff;
        @include ellipsis-line-middle(2,'center');
        @include res-size(
          $width: 845px,
          $bottom:25px,
          $font-size:24px,
          $height:50px,
          $line-height:24px,
        );
      }
  }
  .home {
    height: 100%;
    align-items: center;
    display: flex;
    justify-content: center;
    flex-wrap: nowrap;
    .red-icon {
      position: relative;
      display: inline-block;
      width: 100%;
      height: 100%;
    }
    .red-icon::after {
      background-repeat: no-repeat;
      background-size: 100% 100%;
      content: "";
      position: absolute;
      top: 0;
      @include res-size($height: 18px, $width: 18px, $right: 35px);
    }
    .left {
      .box{
        width: 100%;
        height: 100%;
        position: relative;
        .title{
          position: absolute;
          text-align: center;
          color: #ffdf8a;
          // background: linear-gradient(top,#dccc8c,#a67e38); 
          // background: -webkit-linear-gradient(top,#dccc8c,#a67e38); 
          // -webkit-background-clip: text;
          // color: transparent;
          font-weight: bold;
          @include res-size(
            $height:100px,
            $font-size:50px,
             $left:80px,
            $top:100px,
            $width:343px
          );
         .title-txt{
           height: 100%;
           @include res-size(
            $line-height:50px
          );
           width: 100%;
           text-align: center;
           @include ellipsis-line-middle(2,'center');
         }
        }
        .box-line{
          background-color: #000000;
          box-shadow: 0px 1px 0px 0px 
            rgba(255, 255, 255, 0.3);
          display: block;
          position: absolute;
          @include res-size(
            $top: 495px,
            $width: 318px,
            $height:4px,
            $right:52px);
        }
        .box-label{
          @include ellipsis-line-middle(3,'center');
          position: absolute;
          color:rgba(255, 217, 124, .8);
          text-align: center;
          @include res-size(
            $padding:15px,
             $top: 505px,
            $height: 105px, $width: 318px,
            $font-size:24px,
          $right:52px);
        }
      }
      @include res-size(
        $height: 670px,
        $width: 474px,
        $margin-top: -20px
      );
    }
    .item-warp {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      align-items: center;
      position: absolute;
      @include res-size($top: 180px,$width: 374px,$left:60px);
      .item-gray {
        filter: brightness(0.3) contrast(91%) grayscale(100%);
      }
      .item-bg {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        @include res-size($width: 122px, $height: 122px, $margin: 15px);
      }
      .item {
        @include res-size($width: 90px);
      }
      .current-show {
        position: absolute;
        content: '';
        top: 0;
        left: 0;
        @include res-size($width: 122px, $height: 122px);
      }
    }
    .right {
      background-color: rgba(46, 17, 1, 0.4);
      position: relative;
      @include res-size($height: 625px, $width: 825px, $margin-top:-60px);
      .star-energy{
        float: left;
        font-style: oblique;
        color: #ffd97c;
        background-color: rgba(0, 0, 0, 0.5);
        display: flex;
        align-items: center;
        justify-content: space-between;
        @include res-size(
          // $width:276px,
          $font-size: 50px,
          $height: 64px,$line-height: 64px, $padding-left: 22px,$padding-right: 22px,$margin-top:40px);
        .star{
          display: inline-block;
          @include res-size($height: 52px, $width: 52px,$margin-bottom:8px);
        }
        .energy-txt{
          font-weight: bold;
          @include res-size($margin-left:14px,$margin-right:22px,);
        }
        .energy-now{
          font-weight: bold;
          @include res-size($font-size: 40px,);
          display: inline-block;
        }
      }
      .process-warp{
        position: relative;
        background-color: #000;
        @include res-size($height: 24px,$width:696px,$margin-top:145px,$margin-left:37px);
        .process{
          
          width: 0%;
          @include res-size($height: 24px);
        }
        .split-line{
          position: absolute;
          top: 0;
          left: 25%;
          @include res-size(
            $width:3px,
            $height:24px
          )
        }
        .split-line2{
          left: 50% !important;
        }
        .split-line3{
          left: 75% !important;
        }
        .split-line4{
          left: 100% !important;
        }
        .target-label{
          position: absolute;
          left: 25%;
          color: #d7c176;
          font-style: oblique;
          text-align: center;
          @include res-size(
            $margin-left:-28px,
            $top:-32px,
            $width:60px,
            $height:24px,
            $font-size: 24px
          )
        }
        .gifts{
          position: absolute;
          left: 25%;
          text-align: center;
          @include res-size(
            $margin-left:-16px,
            $top:28px,
            $width:33px,
            $height:34px
          );
          .red-icon{
            position: absolute;
            background-repeat: no-repeat;
            background-size: 100% 100%;
            position: absolute;
            top: 0;
            @include res-size($height: 18px, $width: 18px,$right: -9px,);
          }
          .red-icon::after{
            top: 0;right: 0;
          }
        }
      }
      ::-webkit-scrollbar-thumb {
          background:#ffdd86;
          }
      .task-warp{
        // background-color: rgba(0, 0, 0, 0.45);
        background-color: rgba(46, 17, 1, 0.4);
        @include res-size($height: 394px,$width:756px,$margin-top:60px,$margin-left:20px);
        overflow-x: hidden;
        overflow-y: auto;
        
        .task-item{
          display: flex;
          justify-content: space-between;
          align-items: center;
          border-bottom-style: solid;
          border-bottom-color: rgba(174,128,60,0.36);
          @include res-size($height: 144px,$line-height: 144px,$width:716px,$margin-left:20px,$margin-right:20px,$padding-top:20px,$padding-bottom:20px,$border-bottom-width:2px);
        }
        .score-txt{
            background: linear-gradient(top,#742121,#110505); 
          background: -webkit-linear-gradient(top,#742121,#110505); 
          -webkit-background-clip: text;
          color: transparent;
        }
        .star-task{
          display: inline-block;
          @include res-size($height: 35px,$width:38px);
        }
        .task-txt{
          text-align: left;
          color: #ffdd86;
          @include res-size($height: 104px,$line-height: 27px,$width:350px,$font-size:24px);
          @include ellipsis-line-middle(4,'start');
          display: flex;
          align-items: center;
        }
        .score{
          display: inline-block;
          text-align: center;
          @include res-size($height: 57px,$line-height: 50px,$width:46px,$font-size:32px);
        }
        .fire-up{
          display: inline-block;
          text-align: center;
          @include res-size($height: 62px,$line-height: 57px,$width:204px,$font-size:32px);
          .fire-up-txt-activate{
            color: #fff1da;
            font-style: italic;
          //   background: linear-gradient(top,#742121,#110505); 
          // background: -webkit-linear-gradient(top,#742121,#110505); 
          // -webkit-background-clip: text;
          // color: transparent;
          }
          .fire-up-txt{
            font-style: italic;
            color: #cfcdcd;
          }
        }
      }
    }
    .right::before {
      background-repeat: no-repeat;
      background-size: 100% 100%;
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      @include res-size($height: 670px, $width: 14px);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/task/index.vue